import RoomsFilter from "./RoomsFilter";

export default RoomsFilter;